/**
 * Seeing other members' private items: admins and owners may, in each organization, once they turn it on (off, they
 * see private items like any member, those they're on the list of).
 */
import type { SpaceOut } from "../../api/types.gen.ts";
import { t } from "../../i18n/index.ts";
import { useAction } from "../../lib/resource.ts";
import { atLeast } from "../../lib/roles.ts";
import { setShowPrivate, showsPrivate } from "../../lib/state.ts";
import { Switch } from "../../ui/form.tsx";
import { PrivateIcon } from "../../ui/icons.tsx";
import { Banner } from "../../ui/misc.tsx";

/** The switch, for admins (nothing for anyone else). */
export function OthersPrivateToggle({ space }: { space: SpaceOut }) {
  const [set, busy] = useAction((on: boolean) => setShowPrivate(space, on));
  if (!atLeast(space.role, "admin")) {
    return null;
  }
  return <Switch checked={showsPrivate(space)} disabled={busy} label={t("othersPrivate.toggle")} onCheck={set} />;
}

/** Atop pages showing items while they include other members' private ones, with a button to stop. */
export function OthersPrivateBanner({ space }: { space: SpaceOut }) {
  const [off, busy] = useAction(() => setShowPrivate(space, false));
  if (!showsPrivate(space)) {
    return null;
  }
  return (
    <Banner
      icon={<PrivateIcon size={18} />}
      action={{ label: t("othersPrivate.turnOff"), disabled: busy, onClick: off }}
    >
      <p>
        <b class="font-semibold">{`${t("othersPrivate.bannerTitle")}:`}</b> {t("othersPrivate.banner")}
      </p>
    </Banner>
  );
}
